import React, { Component } from 'react'
import PropTypes from 'prop-types'
import ContentLoader from 'react-content-loader'
import { times } from 'lodash'

export default class ModuleLoader extends Component {
  static propTypes = {
    modulesCount: PropTypes.number,
    moduleWidth: PropTypes.number,
    moduleHeight: PropTypes.number
  }

  static defaultProps = {
    modulesCount: 1,
    moduleWidth: 400,
    moduleHeight: 60
  }

  render() {
    const {
      modulesCount,
      moduleWidth,
      moduleHeight
    } = this.props

    const canvasHeight = modulesCount * moduleHeight

    return (
      <div>
        <ContentLoader
          primaryColor="#f3f3f3"
          secondaryColor="#ecebeb"
          primaryOpacity={0.9}
          secondaryOpacity={0.9}
          style={null}
          height={canvasHeight}
        >

          {/* Pure SVG */}
          {times(modulesCount, index => (
            <rect x="0" y={index * moduleHeight}
                  rx="1" ry="1"
                  width={moduleWidth} height={moduleHeight - 10} />
          ))}
        </ContentLoader>
      </div>
    )
  }
}
